
import {Switch, Route, Redirect} from "react-router-dom"
import Registration from "../Auth/Registration"
import GamesContainer from "../Games"
import Home from "../Home"
import Login from "../Auth/Login"
import { useContext } from "react"
import { UserContext } from "../Context/UserContext"
import Dashboard from "../Dashboard"
import GamesTable from "../Dashboard/GamesTable"
import MoviesTable from "../Dashboard/MoviesTable"
import Movies from "../Movies"
import Profile from "../Dashboard/Profile"
import ChangePassword from "../Auth/ChangePassword"
import GamesForm from "../Dashboard/GamesForm"
import DetailMovies from "../Movies/DetailMovies"
import MoviesForm from "../Dashboard/MoviesForm"


const Routes = () => {
    const [user] = useContext(UserContext)
    return(
        <Switch>
            <Route exact path="/">
                <Home/>
            </Route>
            <Route exact path="/movies">
                <Movies/>
            </Route>
            <Route exact path="/movies/:id/detail">
                <DetailMovies/>
            </Route>
            <Route exact path="/games">
                <GamesContainer/>
            </Route>
            <Route exact path="/registration">
                {!user ? <Registration/> : <Redirect to="/"/>}
            </Route>
            <Route exact path="/login">
                {!user ? <Login/> : <Redirect to="/"/>}
            </Route>
            <Route exact path="/dashboard">
                {user ? <Dashboard/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-games">
                {user ? <GamesTable/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/form-game">
                {user ? <GamesForm/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/form-game/edit/:id">
                {user ? <GamesForm/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-movies">
                {user ? <MoviesTable/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-movies/form">
                {user ? <MoviesForm/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-movies/form/edit/:id">
                {user ? <MoviesForm/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile">
                {user ? <Profile/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile/change-password">
                {user ? <ChangePassword/> : <Redirect to="/login"/>}
            </Route>
            
        </Switch>                   

    )
    
}

export default Routes